import type { DraggingStyle, NotDraggingStyle } from "react-beautiful-dnd";
import { getAppZoom } from "./screenScale";

/**
 * react-beautiful-dnd support for the automatic screen scale (helpers/screenScale.ts).
 *
 * rbd does all its drag logic in on-screen px, which is self-consistent, but the styles
 * it hands us (fixed position, size, translate) are then scaled again by the zoomed
 * document. Converting them back to layout px at render time is all that's needed.
 */
export const scaleRbdDraggableStyle = <T extends DraggingStyle | NotDraggingStyle | undefined>(
  style: T
): T => {
  const zoom = getAppZoom();
  if (!style || zoom === 1) return style;

  const scaled: Record<string, unknown> = { ...style };
  for (const key of ["top", "left", "width", "height"]) {
    const value = scaled[key];
    if (typeof value === "number") scaled[key] = value / zoom;
  }
  if (typeof scaled.transform === "string") {
    scaled.transform = scaled.transform.replace(
      /(-?\d*\.?\d+)px/g,
      (_, px: string) => `${parseFloat(px) / zoom}px`
    );
  }
  return scaled as T;
};
